import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { UserControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent extends ListComponent {

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private userService: UserControllerService) {
      super(translate, sidenavService);

      translate
      .get(['users.button_create', 'icon_refresh', 'action_show'
    ])
      .subscribe((translations: string) => {
        this.topMenuIcons = [
          {icon: "add", title: translations['users.button_create'], routerLink: RouterLinkEnum.USERS.toString() + "new", clickMethod: "dummy", checkDisable:true},
          {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
        ];
        this.actions = [
          {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.USERS.toString(), clickMethod: "dummy"}
        ];
      });
      this.constructorName = 'UsersList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'users.search';
    this.exportPrefix = 'users_';
    this.primarySort.active = 'displayName';
    this.defaultSort.active = 'displayName';
    this.profilesAllowEdit = 'ADMIN';

    super.ngOnInit();

    this.displayedColumns = ['actions', 'displayName', 'email', 'enabled', 'profile'];
  }

  override getItems() {
    super.getItems();
    this.userService.getUsers({ page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction], filter: this.filter.nativeElement.value }).subscribe(
      value  => {
        this.dataSource.data = value['content'];
        this.listIds = this.dataSource.data.map(d => d.id);
        this.totalElements = value['totalElements'];
        this.sidenavService.setLoading(false);
      }
    ,
      error => {
        console.error(JSON.stringify(error));
        this.sidenavService.setLoading(false);
      }
        ,
      () => {
        console.log('done ' + this.dataSource.data.length);
        this.sidenavService.setLoading(false);
      }
    );
  }

}

